import { useEffect, useMemo, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { TaskCard } from "./TaskCard";
import ConfirmationModal from "../../../shared/ui/modal/confirmation-modal";
import axios from "axios";

export function TaskCards({ setTasks, tasks, loading, message }) {
  const [task, setTask] = useState(null);

  const disableModule = async () => {
    const authToken = localStorage.getItem("authToken");

    const response = await axios.patch(
      `${process.env.REACT_APP_ORIGIN}/api/v1/tasks/${task._id}`,
      {
        public: !task.public,
      },
      {
        headers: {
          token: authToken,
        },
      },
    );

    if (response.data.status === "success") {
      const updatedTasks = tasks.map((taskInner) => {
        if (taskInner._id === task._id) {
          console.log("Updating task to", !taskInner.public)
          taskInner.public = !taskInner.public;
        }
        return taskInner;
      });
      setTasks([...updatedTasks]);
    }
  };

  const filteredTasks = useMemo(() => {
    return tasks.filter((task) => task.public);
  },[tasks]);

  return (
    <>
      <div className="task-cards my-3 gy-4">
        {loading ? (
          <div className="text-center">
            <CircularProgress style={{ color: "#FF075B", fontWeight: "600" }} />
          </div>
        ) : filteredTasks.length ? (
          filteredTasks.map((task, index) => (
            <TaskCard
              key={index}
              task={task}
              onDelete={(task) => setTask(task)}
            />
          ))
        ) : (
          <h5 className="text-center" style={{ marginTop: "6%" }}>
            {message}
          </h5>
        )}
      </div>
      {task ? (
        <ConfirmationModal
          message={`Are you sure, you want to remove ${
            task.content?.name || task?.name || ""
          } ${task.taskType} ?`}
          onClose={() => setTask(null)}
          isOpen={true}
          onSubmit={disableModule}
        />
      ) : null}
    </>
  );
}
